/**
 * PC 幅かどうか（FR-123・D-71）。
 *
 * ★ liff は**モバイル前提**（LINE の中で開く）なので、既定はモバイル。PC ブラウザで
 *   開いたとき（06 §6.3 のフォールバック）だけ、縮小版でなく**PC 用のレイアウト**にする。
 *   工務店は事務所の PC からも発注する（D-71＝森井氏の要件追加）。
 * ★ console 側の `useIsMobile` と同じ理由で**アプリ内に置く**（共有パッケージに上げない）。
 * ★ 初期値は同期で取る（初回だけモバイル→PC の二段描画になると E2E が不安定になる）。
 */

import { useEffect, useState } from "react";

export const DESKTOP_QUERY = "(min-width: 1024px)";

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia(DESKTOP_QUERY).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    setIsDesktop(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isDesktop;
}
